var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MaterialCount"},[_c('countTo',{attrs:{"start-val":_vm.startVal,"end-val":_vm.endVal,"duration":_vm.duration}}),_vm._v("\n  +\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }